export interface MangaItem {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  tags: string[];
  description: string;
  rating: number;
  views: number;
  chapters: number;
  updateDate: string;
  status: '连载中' | '已完结';
  featured: boolean;
}

export interface MangaChapter {
  id: string;
  mangaId: string;
  title: string;
  number: number;
  updateDate: string;
  pages: number;
}

export const mangaCategories = [
  { name: '全部', slug: 'all' },
  { name: '日系漫画', slug: 'japanese' },
  { name: '韩系漫画', slug: 'korean' },
  { name: '国产原创', slug: 'chinese' },
  { name: '同人志', slug: 'doujinshi' },
  { name: '轻熟女', slug: 'mature' },
  { name: '纯爱系', slug: 'romance' },
  { name: '剧情向', slug: 'story' },
  { name: '奇幻冒险', slug: 'fantasy' },
  { name: '校园青春', slug: 'school' },
  { name: '职场OL', slug: 'office' },
  { name: '合集系列', slug: 'collection' },
];

export const mangaList: MangaItem[] = [
  {
    id: 'manga-001',
    title: '秘密的课后辅导',
    author: '山田太郎',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20beautiful%20female%20teacher%20in%20classroom%20after%20school%2C%20warm%20sunset%20lighting%20through%20windows%2C%20romantic%20atmosphere%2C%20soft%20colors%2C%20clean%20anime%20art%20style%2C%20cinematic%20composition&width=600&height=800&seq=manga-cover-001&orientation=portrait',
    category: '日系漫画',
    categorySlug: 'japanese',
    tags: ['师生', '纯爱', '校园'],
    description: '一位年轻教师与她的学生之间不可言说的秘密关系，在放学后的教室里悄然展开。细腻的情感刻画与唯美的画风，让这部作品成为近年来最受关注的师生题材漫画之一。',
    rating: 4.8,
    views: 125800,
    chapters: 36,
    updateDate: '2026-08-11',
    status: '连载中',
    featured: true,
  },
  {
    id: 'manga-002',
    title: '邻家姐姐的诱惑',
    author: '金美淑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20a%20mature%20elegant%20woman%20in%20apartment%20setting%2C%20seductive%20gaze%2C%20warm%20indoor%20lighting%2C%20romantic%20mood%2C%20clean%20illustration%20style%2C%20beautiful%20composition&width=600&height=800&seq=manga-cover-002&orientation=portrait',
    category: '韩系漫画',
    categorySlug: 'korean',
    tags: ['姐弟', '日常', '都市'],
    description: '刚搬来隔壁的成熟女性，与年轻男主角之间逐渐升温的暧昧关系。韩系画风精致细腻，人物表情生动传神，故事情节引人入胜。',
    rating: 4.7,
    views: 98200,
    chapters: 48,
    updateDate: '2026-08-10',
    status: '连载中',
    featured: true,
  },
  {
    id: 'manga-003',
    title: '云端之上的恋人',
    author: '铃木花子',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20couple%20embracing%20on%20a%20rooftop%20at%20sunset%2C%20romantic%20sky%20background%2C%20gentle%20warm%20colors%2C%20emotional%20manga%20art%2C%20soft%20lighting%2C%20beautiful%20composition&width=600&height=800&seq=manga-cover-003&orientation=portrait',
    category: '纯爱系',
    categorySlug: 'romance',
    tags: ['纯爱', '校园', '青春'],
    description: '高中时代最纯真的恋爱故事，两个青涩的少年在校园天台相遇，一段跨越三年的动人爱情。画风清新唯美，被誉为近年来最温暖的纯爱漫画。',
    rating: 4.9,
    views: 156300,
    chapters: 24,
    updateDate: '2026-08-12',
    status: '已完结',
    featured: true,
  },
  {
    id: 'manga-004',
    title: '夜之蝶',
    author: '张雨晨',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20mysterious%20woman%20in%20elegant%20dress%20under%20night%20city%20lights%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20beautiful%20dark%20illustration%2C%20cinematic%20mood&width=600&height=800&seq=manga-cover-004&orientation=portrait',
    category: '国产原创',
    categorySlug: 'chinese',
    tags: ['都市', '悬疑', '剧情'],
    description: '夜幕降临后的都市，一位神秘女子游走于上流社会之间，她的真实身份与目的成谜。国产原创精品，剧情扣人心弦，画风华丽精致。',
    rating: 4.6,
    views: 87400,
    chapters: 52,
    updateDate: '2026-08-11',
    status: '连载中',
    featured: false,
  },
  {
    id: 'manga-005',
    title: '幻想乐园',
    author: '田中次郎',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20fantasy%20illustration%20of%20magical%20girl%20in%20dreamlike%20amusement%20park%2C%20colorful%20lights%2C%20whimsical%20atmosphere%2C%20anime%20art%20style%2C%20beautiful%20composition%2C%20soft%20glow&width=600&height=800&seq=manga-cover-005&orientation=portrait',
    category: '同人志',
    categorySlug: 'doujinshi',
    tags: ['同人', '奇幻', '冒险'],
    description: '一部充满想象力的同人作品，将经典角色置于全新的幻想世界中。精美的画工和独特的叙事风格，让这部同人志在圈内广受好评。',
    rating: 4.5,
    views: 65400,
    chapters: 18,
    updateDate: '2026-08-09',
    status: '连载中',
    featured: false,
  },
  {
    id: 'manga-006',
    title: '成熟魅影',
    author: '高桥美咲',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20style%20elegant%20mature%20woman%20in%20office%20attire%2C%20professional%20setting%2C%20confident%20expression%2C%20warm%20ambient%20lighting%2C%20sophisticated%20anime%20art%2C%20clean%20background&width=600&height=800&seq=manga-cover-006&orientation=portrait',
    category: '轻熟女',
    categorySlug: 'mature',
    tags: ['职场', '成熟', 'OL'],
    description: '三十岁的职场女性，在事业与爱情之间寻找平衡。成熟女性特有的魅力与智慧，在这部作品中得到了完美展现。画风优雅大气。',
    rating: 4.7,
    views: 112600,
    chapters: 42,
    updateDate: '2026-08-12',
    status: '连载中',
    featured: true,
  },
  {
    id: 'manga-007',
    title: '剑与玫瑰',
    author: '李梦瑶',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20female%20warrior%20with%20sword%20and%20roses%2C%20ancient%20Chinese%20palace%20background%2C%20dramatic%20composition%2C%20elegant%20illustration%2C%20warm%20golden%20lighting&width=600&height=800&seq=manga-cover-007&orientation=portrait',
    category: '国产原创',
    categorySlug: 'chinese',
    tags: ['古风', '武侠', '奇幻'],
    description: '古代王朝背景下，一位女剑客与王族之间的爱恨纠葛。精美的古风画面与扣人心弦的剧情，展现了中国漫画的独特魅力。',
    rating: 4.8,
    views: 143200,
    chapters: 60,
    updateDate: '2026-08-10',
    status: '已完结',
    featured: false,
  },
  {
    id: 'manga-008',
    title: '樱花树下的约定',
    author: '伊藤健一',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20couple%20under%20blooming%20cherry%20blossom%20tree%2C%20spring%20atmosphere%2C%20pink%20petals%20falling%2C%20romantic%20school%20uniform%2C%20soft%20pastel%20colors%2C%20beautiful%20manga%20art&width=600&height=800&seq=manga-cover-008&orientation=portrait',
    category: '校园青春',
    categorySlug: 'school',
    tags: ['校园', '青春', '纯爱'],
    description: '毕业季的樱花树下，青梅竹马的两人许下了永远的约定。纯真美好的校园恋爱故事，让人回忆起青春最美好的时光。',
    rating: 4.6,
    views: 78900,
    chapters: 20,
    updateDate: '2026-08-08',
    status: '已完结',
    featured: false,
  },
  {
    id: 'manga-009',
    title: '办公室的秘密',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20office%20romance%20scene%2C%20two%20colleagues%20in%20modern%20office%2C%20evening%20overtime%20atmosphere%2C%20city%20view%20through%20window%2C%20romantic%20tension%2C%20clean%20illustration&width=600&height=800&seq=manga-cover-009&orientation=portrait',
    category: '职场OL',
    categorySlug: 'office',
    tags: ['职场', '办公室', '都市'],
    description: '加班夜里的办公室，两位同事之间悄然滋生的情愫。职场中的禁忌之恋，在繁忙的工作间隙中慢慢升温。韩系写实画风极具代入感。',
    rating: 4.5,
    views: 92100,
    chapters: 34,
    updateDate: '2026-08-11',
    status: '连载中',
    featured: false,
  },
  {
    id: 'manga-010',
    title: '异世界后宫物语',
    author: '佐藤大辅',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20isekai%20fantasy%20manga%20illustration%2C%20male%20hero%20surrounded%20by%20beautiful%20female%20characters%20in%20fantasy%20world%2C%20magical%20atmosphere%2C%20adventure%20theme%2C%20vibrant%20anime%20art%20style&width=600&height=800&seq=manga-cover-010&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    tags: ['异世界', '后宫', '冒险'],
    description: '普通上班族意外穿越到魔法世界，在这个充满奇幻色彩的异世界中展开了一段波澜壮阔的冒险之旅。经典的后宫向作品，人物塑造丰满。',
    rating: 4.4,
    views: 134500,
    chapters: 72,
    updateDate: '2026-08-12',
    status: '连载中',
    featured: false,
  },
  {
    id: 'manga-011',
    title: '温泉旅馆物语',
    author: '中村优子',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20illustration%20of%20beautiful%20woman%20in%20yukata%20at%20traditional%20hot%20spring%20inn%2C%20steam%20atmosphere%2C%20warm%20lighting%2C%20tatami%20room%2C%20relaxing%20mood%2C%20elegant%20anime%20art&width=600&height=800&seq=manga-cover-011&orientation=portrait',
    category: '日系漫画',
    categorySlug: 'japanese',
    tags: ['温泉', '旅行', '浪漫'],
    description: '深山中的温泉旅馆，成为各种缘分交汇的舞台。每一位到访的客人都带着自己的故事，在温泉的蒸汽中，秘密与欲望交织缠绕。',
    rating: 4.7,
    views: 108900,
    chapters: 28,
    updateDate: '2026-08-10',
    status: '连载中',
    featured: false,
  },
  {
    id: 'manga-012',
    title: '暗夜之瞳',
    author: '王浩然',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20dark%20fantasy%20female%20character%20with%20mysterious%20eyes%2C%20gothic%20style%2C%20moonlit%20night%20scene%2C%20dramatic%20shadows%2C%20beautiful%20detailed%20illustration%2C%20dark%20romantic%20mood&width=600&height=800&seq=manga-cover-012&orientation=portrait',
    category: '国产原创',
    categorySlug: 'chinese',
    tags: ['暗黑', '奇幻', '悬疑'],
    description: '拥有特殊能力的少女，在黑暗世界中寻找真相。独特的暗黑画风与紧凑的剧情节奏，让这部国产原创作品在读者中获得极高评价。',
    rating: 4.9,
    views: 167800,
    chapters: 44,
    updateDate: '2026-08-11',
    status: '连载中',
    featured: true,
  },
  {
    id: 'manga-013',
    title: '甜蜜陷阱',
    author: '崔恩智',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20illustration%2C%20beautiful%20woman%20in%20cafe%20setting%2C%20sweet%20desserts%20on%20table%2C%20warm%20cozy%20atmosphere%2C%20romantic%20mood%2C%20clean%20modern%20art%20style&width=600&height=800&seq=manga-cover-013&orientation=portrait',
    category: '韩系漫画',
    categorySlug: 'korean',
    tags: ['恋爱', '都市', '甜宠'],
    description: '甜品店老板与常客之间的甜蜜恋爱故事。每一话都像精致的甜点一样令人心动，是放松心情的最佳选择。韩系清新华美的画风。',
    rating: 4.6,
    views: 76500,
    chapters: 30,
    updateDate: '2026-08-09',
    status: '已完结',
    featured: false,
  },
  {
    id: 'manga-014',
    title: '同窗会',
    author: '松本润子',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20class%20reunion%20scene%2C%20group%20of%20adults%20in%20izakaya%2C%20nostalgic%20warm%20atmosphere%2C%20cherry%20blossom%20theme%2C%20emotional%20expressions%2C%20beautiful%20anime%20art&width=600&height=800&seq=manga-cover-014&orientation=portrait',
    category: '剧情向',
    categorySlug: 'story',
    tags: ['重逢', '怀旧', '剧情'],
    description: '十年后的同窗会，曾经的同学重逢，尘封的记忆与未了的情缘被重新唤醒。成年人的感情世界复杂而深刻，引人深思。',
    rating: 4.8,
    views: 89300,
    chapters: 16,
    updateDate: '2026-08-12',
    status: '已完结',
    featured: false,
  },
  {
    id: 'manga-015',
    title: '女王的花园',
    author: '赵灵儿',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20elegant%20queen%20in%20beautiful%20garden%20full%20of%20roses%2C%20ancient%20Chinese%20palace%20style%2C%20golden%20sunset%20lighting%2C%20luxurious%20atmosphere%2C%20detailed%20illustration&width=600&height=800&seq=manga-cover-015&orientation=portrait',
    category: '国产原创',
    categorySlug: 'chinese',
    tags: ['宫廷', '古风', '女强'],
    description: '一位传奇女帝的崛起之路，在权谋与情感的交织中书写不朽传奇。宏大的世界观与精美的古风画面，展现了国产漫画的最高水准。',
    rating: 4.9,
    views: 189200,
    chapters: 56,
    updateDate: '2026-08-11',
    status: '连载中',
    featured: true,
  },
  {
    id: 'manga-016',
    title: '禁忌之恋',
    author: '山本凉子',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20forbidden%20love%20theme%2C%20two%20characters%20in%20rainy%20Tokyo%20street%2C%20melancholic%20atmosphere%2C%20wet%20reflections%2C%20emotional%20dramatic%20scene%2C%20beautiful%20detailed%20anime%20art&width=600&height=800&seq=manga-cover-016&orientation=portrait',
    category: '剧情向',
    categorySlug: 'story',
    tags: ['禁忌', '剧情', '虐心'],
    description: '一段不被世俗接纳的爱情，两个灵魂在挣扎中相互取暖。深刻的情感描写与细腻的心理刻画，让这部作品成为不可多得的佳作。',
    rating: 4.7,
    views: 101400,
    chapters: 38,
    updateDate: '2026-08-10',
    status: '连载中',
    featured: false,
  },
];

export const mangaChapters: MangaChapter[] = [
  { id: 'ch-001-1', mangaId: 'manga-001', title: '第一话：放学后的邂逅', number: 1, updateDate: '2026-06-01', pages: 28 },
  { id: 'ch-001-2', mangaId: 'manga-001', title: '第二话：补课的借口', number: 2, updateDate: '2026-06-08', pages: 30 },
  { id: 'ch-001-3', mangaId: 'manga-001', title: '第三话：雨中的两人', number: 3, updateDate: '2026-06-15', pages: 26 },
  { id: 'ch-001-4', mangaId: 'manga-001', title: '第四话：心跳的距离', number: 4, updateDate: '2026-06-22', pages: 32 },
  { id: 'ch-001-5', mangaId: 'manga-001', title: '第五话：无法言说的秘密', number: 5, updateDate: '2026-06-29', pages: 28 },
  { id: 'ch-001-6', mangaId: 'manga-001', title: '第六话：夏天的约定', number: 6, updateDate: '2026-07-06', pages: 30 },
  { id: 'ch-003-1', mangaId: 'manga-003', title: '第一话：天台上的少女', number: 1, updateDate: '2026-04-01', pages: 24 },
  { id: 'ch-003-2', mangaId: 'manga-003', title: '第二话：午后的阳光', number: 2, updateDate: '2026-04-15', pages: 26 },
  { id: 'ch-003-3', mangaId: 'manga-003', title: '第三话：樱花飞舞的季节', number: 3, updateDate: '2026-05-01', pages: 28 },
  { id: 'ch-003-4', mangaId: 'manga-003', title: '第四话：夏日祭典', number: 4, updateDate: '2026-05-15', pages: 30 },
  { id: 'ch-003-5', mangaId: 'manga-003', title: '第五话：告白', number: 5, updateDate: '2026-06-01', pages: 32 },
  { id: 'ch-003-6', mangaId: 'manga-003', title: '第六话：永远在一起', number: 6, updateDate: '2026-06-15', pages: 26 },
];

export const featuredMangaIds = ['manga-001', 'manga-002', 'manga-003', 'manga-006', 'manga-012', 'manga-015'];